module.exports = __webpack_public_path__ + "img/pro-d2.bc136813.png";